import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {FeatureFlag} from '../data/featureflag/feature-flag.model';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import { ISupportInquiry } from '../data/notification/support.inquiry.model';

@Injectable({
  providedIn: 'root'
})
export class WorkflowService
{
  constructor(private http: HttpClient) { }

  getFeatureFlag(tenantId: string): Observable<FeatureFlag>
  {
    return this.http.get<FeatureFlag>(environment.workflowApiBaseUrl + `v1/tenants/${tenantId}/feature-flags`);
  }

  sendSupportInquiry(tenantId: string, inquiry: ISupportInquiry): Observable<any>
  {
    return this.http.post<void>(environment.workflowApiBaseUrl + `v1/tenants/${tenantId}/notifications/support-inquiry`, inquiry);
  }

}
